import React from 'react';
import { useSelector } from 'react-redux';
import { selectSiteUrl } from 'core/selectors/app';
import { trackInsiderEmailOptinEvent } from 'core/utils/analytics/insiderAnalytics';
import ContentWrap from 'core/modules/Partials/ContentWrap/ContentWrap';
import config from 'core/modules/EmailUnsubscribe/configs';
import { dyEvents } from 'core/utils/analytics/dyAnalytics';
import { usePrepareUnsubscribeUrl, useGetBrandId } from '../hooks';

function Form({ data }) {
  const siteUrl = useSelector(selectSiteUrl);
  const brandId = useGetBrandId();
  const prepareUnsubscribeUrl = usePrepareUnsubscribeUrl(data);

  const isGlobal = data.stream === 'global';
  const isFavorites = data.stream === 'favorites';
  const { getGlobalConfirmText, getFavoritesConfirmText, getDefaultConfirmText } = config;

  const renderConfirmText = () => {
    if (isGlobal) return getGlobalConfirmText(data.streamTitle);
    if (isFavorites) return getFavoritesConfirmText(data.streamTitle, siteUrl);
    return getDefaultConfirmText();
  };

  const sendEmailOptOutDyEvent = () => {
    if (isGlobal) {
      const emailPopupCookie = { lastSeen: 'na', seenCount: 'na', emailGlobalOptOut: '1' };
      dyEvents.sendEvent(dyEvents.sendEmailOptinEvent, { emailPopupCookie });
      trackInsiderEmailOptinEvent(emailPopupCookie);
    }
  };

  return (
    <div className="mn_emailUnsubscribe">
      <ContentWrap className="mn_unsubscribeForm">
        <div className="mn_confirmText">{renderConfirmText()}</div>
        <div className="mn_details">
          {!isGlobal && !isFavorites &&
          <p>
            <span className="mn_detailLabel">Newsletter:</span>
            <span className="mn_detailValue">{data.streamTitle}</span>
          </p>
          }
          <p>
            <span className="mn_detailLabel">Email address:</span>{' '}
            <span className="mn_detailValue">{data.email}</span>{' '}
            (<a href={data.profileLoginUrl}>Not you?</a>)
          </p>
        </div>
        <form method="POST" data-ajax="false" action={`${siteUrl}/member.php`}>
          <input type="hidden" name="form" value="UnsubscribeMember" />
          <input type="hidden" name="cbUrl" value={prepareUnsubscribeUrl({ act: 'Confirm' })} />
          <input type="hidden" name="fcbUrl" value={prepareUnsubscribeUrl()} />
          <input type="hidden" name="fs" value={data.formsecurity} />
          <input type="hidden" name="ues" value={data.stream} />
          <input type="hidden" name="uid" value={data.memberId} />
          <input type="hidden" name="bid" value={brandId} />
          <div className="mn_buttons">
            <input type="submit" className="mn_button" name="act" value="Confirm" onClick={sendEmailOptOutDyEvent} />
            <a
              className="mn_button mn_cancelButton mn_secondaryButton"
              href={data.isBookable ? siteUrl : prepareUnsubscribeUrl({ act: 'Cancel' })}
            >
              Cancel
            </a>
          </div>
        </form>
      </ContentWrap>
    </div>
  );
}

export default Form;
